export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};


export const messages = {
    "login.form.title": "Aanmelden",
    "login.form.hint.user": "Gebruikersnaam",
    "login.form.hint.password": "Wachtwoord",
    "login.form.checkbox.remember-me": "Onthoud mij",
    "login.form.button.sign-in": "Aanmelden",
    "login.form.message.invalid-user-credentials": "Gebruikersnaam of wachtwoord is onjuist",
    "login.form.message.user-required": "Voer een gebruikersnaam in",
    "login.form.message.password-required": "Voer een wachtwoord in",
    "login.form.button.forgot-password": "Wachtwoord vergeten?",
    "error.root-admin-login.title": "Fout 403 – verboden",
    "error.root-admin-login.message": "U bent ingelogd als alleen-lezen beheerder. Als u toegang wilt krijgen tot de Web Recovery Console, moet u zich aanmelden als gebruiker van een klanttenant of als beheerder"
};
